import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_gtm_aac6dec8 from 'nuxt_plugin_gtm_aac6dec8' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_pluginrouting_65c2f280 from 'nuxt_plugin_pluginrouting_65c2f280' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_6515dcaf from 'nuxt_plugin_pluginmain_6515dcaf' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_http_4348fd6c from 'nuxt_plugin_http_4348fd6c' // Source: ./http.js (mode: 'all')
import nuxt_plugin_recaptcha_1f812896 from 'nuxt_plugin_recaptcha_1f812896' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_vuescrollto_73c6db03 from 'nuxt_plugin_vuescrollto_73c6db03' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_libplugin374c4d94_66173b28 from 'nuxt_plugin_libplugin374c4d94_66173b28' // Source: ./lib.plugin.374c4d94.js (mode: 'all')
import nuxt_plugin_filters_2b4f519a from 'nuxt_plugin_filters_2b4f519a' // Source: ../plugins/filters.js (mode: 'all')
import nuxt_plugin_api_6e03a23a from 'nuxt_plugin_api_6e03a23a' // Source: ../plugins/api (mode: 'all')
import nuxt_plugin_persistedstate_ba07b200 from 'nuxt_plugin_persistedstate_ba07b200' // Source: ../plugins/persisted-state (mode: 'all')
import nuxt_plugin_eventbus_0465ae7d from 'nuxt_plugin_eventbus_0465ae7d' // Source: ../plugins/eventbus (mode: 'all')
import nuxt_plugin_gmap_56ca5bec from 'nuxt_plugin_gmap_56ca5bec' // Source: ../plugins/gmap (mode: 'all')
import nuxt_plugin_inputmask_d27fb3b4 from 'nuxt_plugin_inputmask_d27fb3b4' // Source: ../plugins/input-mask (mode: 'all')
import nuxt_plugin_crisp_fb69af80 from 'nuxt_plugin_crisp_fb69af80' // Source: ../plugins/crisp (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    return this.$root.$options.$nuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Fireflies","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, shrink-to-fit=no"},{"property":"og:title","content":"Fireflies"},{"property":"twitter:title","content":"Fireflies"},{"property":"og:image","content":"\u002Fimages\u002Fog-image.png"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Fimages\u002Ffavicon.png"},{"rel":"stylesheet","href":"\u002Fwebfonts\u002Ffonts.css"},{"rel":"preload","as":"font","crossorigin":"crossorigin","type":"font\u002Fwoff2","href":"\u002Fwebfonts\u002Ffa-brands-400.woff2"},{"rel":"preload","as":"font","crossorigin":"crossorigin","type":"font\u002Fwoff2","href":"\u002Fwebfonts\u002Ffa-duotone-900.woff2"},{"rel":"preload","as":"font","crossorigin":"crossorigin","type":"font\u002Fwoff2","href":"\u002Fwebfonts\u002Ffa-light-300.woff2"},{"rel":"preload","as":"font","crossorigin":"crossorigin","type":"font\u002Fwoff2","href":"\u002Fwebfonts\u002Ffa-regular-400.woff2"},{"rel":"preload","as":"font","crossorigin":"crossorigin","type":"font\u002Fwoff2","href":"\u002Fwebfonts\u002Ffa-solid-900.woff2"}],"style":[],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":""}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_gtm_aac6dec8 === 'function') {
    await nuxt_plugin_gtm_aac6dec8(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_65c2f280 === 'function') {
    await nuxt_plugin_pluginrouting_65c2f280(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_6515dcaf === 'function') {
    await nuxt_plugin_pluginmain_6515dcaf(app.context, inject)
  }

  if (typeof nuxt_plugin_http_4348fd6c === 'function') {
    await nuxt_plugin_http_4348fd6c(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_1f812896 === 'function') {
    await nuxt_plugin_recaptcha_1f812896(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_73c6db03 === 'function') {
    await nuxt_plugin_vuescrollto_73c6db03(app.context, inject)
  }

  if (typeof nuxt_plugin_libplugin374c4d94_66173b28 === 'function') {
    await nuxt_plugin_libplugin374c4d94_66173b28(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_2b4f519a === 'function') {
    await nuxt_plugin_filters_2b4f519a(app.context, inject)
  }

  if (typeof nuxt_plugin_api_6e03a23a === 'function') {
    await nuxt_plugin_api_6e03a23a(app.context, inject)
  }

  if (typeof nuxt_plugin_persistedstate_ba07b200 === 'function') {
    await nuxt_plugin_persistedstate_ba07b200(app.context, inject)
  }

  if (typeof nuxt_plugin_eventbus_0465ae7d === 'function') {
    await nuxt_plugin_eventbus_0465ae7d(app.context, inject)
  }

  if (typeof nuxt_plugin_gmap_56ca5bec === 'function') {
    await nuxt_plugin_gmap_56ca5bec(app.context, inject)
  }

  if (typeof nuxt_plugin_inputmask_d27fb3b4 === 'function') {
    await nuxt_plugin_inputmask_d27fb3b4(app.context, inject)
  }

  if (typeof nuxt_plugin_crisp_fb69af80 === 'function') {
    await nuxt_plugin_crisp_fb69af80(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
